export default __webpack_public_path__ + "static/media/pic3.b855cae4.jpg";